<div [ngClass]="{ disabled: disabled }">
  <mat-icon
    *ngFor="let item of [].constructor(max); index as i"
    (click)="onClick(i + 1)"
    >{{ i + 1 <= value ? "star" : "star_border" }}</mat-icon
  >
</div>
